import { useMutation } from '@tanstack/react-query'

import { sendBookingEmail } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  internal_id?: ParameterID
  cc?: string
  subject?: string
  body?: string
  attachment_document_ids?: number[]
}

export function useMutationSendBookingEmail() {
  return useMutation({
    mutationKey: ['MutationSendBookingEmail'],
    mutationFn: async ({
      internal_id,
      cc,
      subject,
      body,
      attachment_document_ids,
    }: MutationPayload) => {
      const response = await sendBookingEmail(internal_id ?? '', {
        cc,
        subject,
        body,
        attachment_document_ids,
      })
      return response
    },
  })
}
